import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3ae105c6"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["href"];
const _hoisted_2 = {
  class: "circle"
};
const _hoisted_3 = {
  class: "info"
};
const _hoisted_4 = {
  class: "truncate"
};
const _hoisted_5 = {
  class: "count"
};
const _hoisted_6 = {
  key: 0,
  class: "close"
};
const _hoisted_7 = {
  class: "status"
};
export default {
  __name: 'CompanyCard',
  props: {
    /**
     * 狀態
     * finish: 處理中
     * process: 完成
     * wait: 維修
     */
    status: {
      default: 'process'
    },
    data: Object
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_f7_icon = _resolveComponent("f7-icon");
      return _openBlock(), _createElementBlock("a", {
        class: _normalizeClass(["company-card", __props.status]),
        href: '/company/' + __props.data.serviceSaleID
      }, [_createElementVNode("div", _hoisted_2, _toDisplayString(__props.data.index), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(__props.data.name), 1), _createElementVNode("div", null, [_createElementVNode("span", null, [_createVNode(_component_f7_icon, {
        icon: "icon-document",
        size: "14px"
      }), _createTextVNode(" " + _toDisplayString(__props.data.serviceSalesNumber), 1)]), _createElementVNode("span", _hoisted_5, [_createVNode(_component_f7_icon, {
        icon: "icon-repair",
        size: "14px"
      }), _createTextVNode(" " + _toDisplayString(__props.data.subCount), 1)]), __props.data.close_the_case != 0 ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Close ")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_7, [__props.status === 'process' ? (_openBlock(), _createBlock(_component_f7_icon, {
        key: 0,
        icon: "icon-tag-repair",
        size: "34px"
      })) : __props.status === 'finish' ? (_openBlock(), _createBlock(_component_f7_icon, {
        key: 1,
        icon: "icon-tag-check",
        size: "28px"
      })) : __props.status === 'wait' ? (_openBlock(), _createBlock(_component_f7_icon, {
        key: 2,
        icon: "icon-tag-exclamation-mark",
        size: "34px"
      })) : _createCommentVNode("", true)])], 10, _hoisted_1);
    };
  }
};